import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { AppStore } from '../../shared/store/lookup-store.service';
import { JobsStore } from '../../jobs/store/jobs-store.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class HomeResolver implements Resolve<any> {
  constructor(
    private jobStore: JobsStore,
    private lookupStore: AppStore,
    private spinner: NgxSpinnerService
  ) {}
  resolve(route: ActivatedRouteSnapshot): Promise<any> {
    this.spinner.show();
    return Promise.all([
      this.lookupStore.loadInitialData(),
      this.jobStore.getLatestJobs(),
    ]).catch((error) => {
      this.lookupStore.setIsLookupDataLoaded(true);
    });
  }
}
